import { QueryHookOptions, useQuery } from '@apollo/react-hooks'
import { SERVICES_QUERY } from 'apollo'
import { merge } from 'merge-anything'

const DEFAULTS = {
  variables: {
    query: {},
  },
}

export const useServicesQuery = (options: QueryHookOptions<any, any> = {}) =>
  useQuery(SERVICES_QUERY, merge(options, DEFAULTS))
